import { render, staticRenderFns } from "./CmgAchievedBadgeModal.vue?vue&type=template&id=556b2b92&scoped=true&lang=pug&"
import script from "./cmg-achieved-badge-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-achieved-badge-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgAchievedBadgeModal.vue?vue&type=style&index=0&id=556b2b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b2b92",
  null
  
)

export default component.exports